import React from 'react';
import { NavLink } from 'react-router-dom';

import Img from '../../../../components/Img';
import AppNavbar from '@/AppNavbar';
import SideBar from "@/app/layout/SideBar";
import { connect } from 'react-redux';
import { withRouter } from '../../../helpers/withRouter';
import { Translation } from "react-i18next";
import EventTopNavBar from '@/app/layout/EventTopNavBar';
import EventbuizzFooter from '../../EventbuizzFooter';
const MasterLayout = ({ children, history, ...rest }) => {
    return (
        <Translation>
            {t => (
                <div id="App" className="inner-pages">
                    <AppNavbar cancel="active" children={children} />
                    <main role="main" className="main-section">
                        <div className="container">
                            <div className="wrapper-box">
                                <div className="top-landing-page">
                                    <div className="row d-flex">
                                        <div className="col-3">
                                            <div className="logo innerpageLogo">
                                                <NavLink to={`/`}>
                                                    <Img alt="Plug'n'Play" width="180" src={require("img/logos.svg")} />
                                                </NavLink>
                                            </div>
                                        </div>
                                        {!window.location.pathname.includes('/event/create') && !window.location.pathname.includes('/account/organizer/') && (
                                            <EventTopNavBar children={children} />
                                        )}
                                    </div>
                                </div>
                                <SideBar
                                    children={children}
                                />
                            </div>
                        </div>
                    </main>
                    <EventbuizzFooter />
                </div>
            )}
        </Translation>
    );
}

class MasterLayoutRoute extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            default_template_id: (this.props.event !== undefined ? this.props.event.default_template_id : null),
            event: this.props.event,
        };
    }

    static getDerivedStateFromProps(props, state) {
        if (props.event.id !== undefined && state.event.id !== props.event.id) {
            return {
                event: props.event,
                default_template_id: (props.event !== undefined ? props.event.default_template_id : null),
            };
        }
        // Return null to indicate no change to state.
        return null;
    }

    render() {
        const { children } = this.props;
        return (
            <MasterLayout history={this.props.history}>
                {children}
            </MasterLayout>
        )
    }
};

function mapStateToProps(state) {
    const { event } = state;
    return {
        event
    };
}
export default connect(mapStateToProps)(withRouter(MasterLayoutRoute));